import { getFontFamilyCss } from '@/utils/chartTitlePresets'

/** 侧栏 fontStyle 开关（含 handleFontStyle 写入的随机数等非空真值） */
export function isRichFontStyleFlagOn (v) {
  if (v == null || v === '' || v === false || v === 0) return false
  return true
}

/** 与画布/查看页一致：指标库且已选指标 → 正文只读、版式仅侧栏 */
export function isRichTextIndicatorReadonly (dataSource, selectedIndicatorIdList) {
  return dataSource === 'indicatorLib' && selectedIndicatorIdList?.length > 0
}

export function normalizeRichTextFontSizePx (v) {
  const n = Number(v)
  if (!Number.isFinite(n)) return 0
  return Math.max(8, Math.min(300, Math.round(n)))
}

/**
 * 富文本容器内联样式：字号/颜色/对齐/字体；B/I/U/S 是否打在容器上由 omitCharacterStyles 控制。
 * - 指标只读：omitCharacterStyles=false，段落 .rich-indicator-line 用 inherit，侧栏独占版式。
 * - 自定义编辑：omitCharacterStyles=true，B/I/U/S 只通过 execCommand 进 HTML，避免与容器 text-decoration 叠加导致无法去掉。
 */
export function getRichTextContainerStyle ({ titleStyle, omitCharacterStyles = false }) {
  const t = titleStyle || {}
  const fst = t.fontStyle || {}
  const fs = normalizeRichTextFontSizePx(fst.fontSize) || 22
  const ff = getFontFamilyCss(t.fontFamily)
  const style = {
    fontSize: `${fs}px`,
    color: t.color || fst.color || undefined,
    textAlign: t.align || undefined,
  }
  if (ff) style.fontFamily = ff
  if (!omitCharacterStyles) {
    if (isRichFontStyleFlagOn(fst.bold)) style.fontWeight = '700'
    if (isRichFontStyleFlagOn(fst.italic)) style.fontStyle = 'italic'
    const deco = []
    if (isRichFontStyleFlagOn(fst.underline)) deco.push('underline')
    if (isRichFontStyleFlagOn(fst.strikeThrough)) deco.push('line-through')
    if (deco.length) style.textDecoration = deco.join(' ')
  }
  return style
}
